import { render, staticRenderFns } from "./InspIndexDetail.vue?vue&type=template&id=7bc1a750&scoped=true&"
import script from "./InspIndexDetail.vue?vue&type=script&lang=js&"
export * from "./InspIndexDetail.vue?vue&type=script&lang=js&"
import style0 from "./InspIndexDetail.vue?vue&type=style&index=0&id=7bc1a750&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc1a750",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VCardText,VCardTitle,VSimpleTable})
